module.exports = __webpack_public_path__ + "img/package (1).52684402.png";